import { Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges } from '@angular/core';
import { ContratoService } from 'administrativo-lib';
import { Contrato, FuncaoService, Licitacao, Login, Proponente } from 'eddydata-lib';
import { ConfirmationService } from 'primeng/api';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
// import * as toastr from 'toastr';

declare var $: any;

@Component({
  selector: 'app-contrato-licitacao',
  templateUrl: './contrato-licitacao.component.html'
})
export class ContratoLicitacaoComponent implements OnInit, OnDestroy, OnChanges {

  @Input() entidade: Licitacao;
  @Input() login: Login;

  public listaPendentes: Proponente[];
  public pendenteAtual: Proponente;

  protected unsubscribe: Subject<void> = new Subject();

  constructor(
    protected confirmationService: ConfirmationService,
    public funcaoService: FuncaoService,
    public contratoService: ContratoService,
  ) { }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes?.entidade) {
      this.listaPendentes = this.contratoService.obterContratosPendentesLicitacao(this.entidade);
    }
  }

  ngOnInit(): void {
  }

  ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }

  public totalizarPendente(proponente: Proponente): number {
    let total = 0;
    proponente.propostas.forEach(p => total += +Number(+p.quantidade_final * +p.valor_final).toFixed(2))
    return total;
  }

  public incluirContrato(proponente: Proponente) {
    this.pendenteAtual = proponente;
    $('#dialogContratoLicitacao').modal('show');
  }

  public callbackContrato(contrato: Contrato) {
    this.contratoService.obterPorLicitacao(this.entidade.id, this.login.orgao.id).pipe(takeUntil(this.unsubscribe))
      .subscribe((res) => {
        this.entidade.contratos = res ? res.content : [];
        this.listaPendentes = this.contratoService.obterContratosPendentesLicitacao(this.entidade);
      }, error => toastr.error(error.message ? error.message : error));

  }
}
